(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroScroll() {
    var heroes = document.querySelectorAll('[data-gh-hero]');
    if (!heroes.length || prefersReducedMotion) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        heroes.forEach(function (hero) {
          if (window.scrollY > 40) {
            hero.setAttribute('data-gh-scrolled', '');
          } else {
            hero.removeAttribute('data-gh-scrolled');
          }
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function animateCountUp(el) {
    var target = parseFloat(el.getAttribute('data-value'));
    if (isNaN(target)) return;
    var targetEl = el.querySelector('[data-gh-countup-target]') || el;
    var decimals = el.getAttribute('data-decimals') ? parseInt(el.getAttribute('data-decimals'), 10) : 0;

    if (prefersReducedMotion) {
      targetEl.textContent = target.toLocaleString(undefined, { maximumFractionDigits: decimals, minimumFractionDigits: decimals });
      return;
    }

    var duration = 1300;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      targetEl.textContent = value.toLocaleString(undefined, { maximumFractionDigits: decimals, minimumFractionDigits: decimals });
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        targetEl.textContent = target.toLocaleString(undefined, { maximumFractionDigits: decimals, minimumFractionDigits: decimals });
      }
    }
    window.requestAnimationFrame(step);
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-gh-countup]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(animateCountUp);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCountUp(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeroScroll();
      initCountUp();
    });
  } else {
    initHeroScroll();
    initCountUp();
  }
})();
